import type { ComponentProps, ComponentPropsWithRef, ReactNode } from 'react';
import type { TooltipContentProps } from '@radix-ui/react-tooltip';
import { Content, Portal, Provider, Root, Trigger } from '@radix-ui/react-tooltip';

import { cn } from '@/utils/styles';

/** @deprecated Use `Tooltip` from `@/modus/Tooltip` instead. */
const TooltipContent = ({ className, sideOffset = 4, ref, ...props }: ComponentPropsWithRef<typeof Content>) => (
  <Portal>
    <Content
      ref={ref}
      sideOffset={sideOffset}
      className={cn(
        'z-50 origin-(--radix-tooltip-content-transform-origin) overflow-hidden rounded-md border border-white/10 bg-popover px-3 py-1.5 text-xs text-white/70 animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
        className,
      )}
      {...props}
    />
  </Portal>
);

TooltipContent.displayName = Content.displayName;

/** @deprecated Use `Tooltip` from `@/modus/Tooltip` instead. */
const TooltipRoot = ({ delayDuration = 300, ...props }: ComponentProps<typeof Root>) => (
  <Root delayDuration={delayDuration} {...props} />
);

// Create a compound component
const TooltipComponent = TooltipRoot as typeof TooltipRoot & {
  Provider: typeof Provider;
  Trigger: typeof Trigger;
  Content: typeof TooltipContent;
};

TooltipComponent.Provider = Provider;
TooltipComponent.Trigger = Trigger;
TooltipComponent.Content = TooltipContent;

/** @deprecated Use `Tooltip` from `@/modus/Tooltip` instead. */
export const Tooltip = TooltipComponent;

export type { TooltipContentProps };

/** @deprecated Use `Tooltip` from `@/modus/Tooltip` instead. */
export type ComponentWithTooltipProps = {
  tooltipContent?: ReactNode;
  tooltipProps?: TooltipContentProps;
};
